import React, {
  Fragment,
  useContext,
  useEffect,
  useState,
  useRef,
  useMemo,
  useCallback,
} from "react";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
//import { makeStyles } from 'tss-react/mui';
import Autocomplete from "@mui/material/Autocomplete";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import throttle from "lodash/throttle";
import parse from "autosuggest-highlight/parse";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import useMediaQuery from "@mui/material/useMediaQuery";
//import { useTheme } from '@mui/material/styles';
import Box from "@mui/material/Box";
import Spinner from "../Spinner";
//import { selectedRowsCountSelector } from "@material-ui/data-grid";
import { ServiciosContext } from "../../../context/ServiciosContext";
import { ConfiguracionContext } from "../../../context/ConfiguracionContext";
import { AlertContext } from "../../../context/AlertContext";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import { NumericFormat } from "react-number-format";
import { Toast } from "primereact/toast";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "../../../assets/css/DialogDemo.css";
import "../../../assets/css/DropDown.css";
import { Tag } from "primereact/tag";
import ClearIcon from "@mui/icons-material/Clear";
import { TextareaAutosize } from "@mui/base";
import {
  MapContainer,
  TileLayer,
  Marker,
  Popup,
  Tooltip,
  useMap,
  latLngBound,
} from "react-leaflet";
import "./Map.css";
import { styled } from "@mui/material/styles";
import { Navigate, useNavigate } from "react-router-dom";
import { Dropdown } from "primereact/dropdown";
import { DataView } from "primereact/dataview";

const PREFIX = "DatosServicio";
const classes = {
  root: `${PREFIX}-root`,
};

const Root = styled("div")(({ theme }) => ({
  [`&.${classes.root}`]: {
    display: "flex",
    margin: "1vw",
  },
}));

export default function DatosServicio(props) {
  //const classes = useStyles();
  const [afiliadoCartera, guardarAfiliadoCartera] = useState(null);
  const [iniciarCursor, setIniciarCursor] = useState(0);
  const [coseguro, setCoseguro] = useState(0);
  const [bandInicio, setBandInicio] = useState(true);
  const [visibleServiciosDni, setVisibleServiciosDni] = useState(false);
  const toast = useRef(null);
  const toastC = useRef(null);
  const toastTL = useRef(null);
  const toastBL = useRef(null);
  const [position, setPosition] = useState(null);

  const serviciosContext = useContext(ServiciosContext);
  const {
    afiliado,
    titular,
    direcciones,
    serviciosDni,
    guardarAfiliado,
    guardarTomaAzul,
    guardarTomaNaranja,
    setOpenModalAzul,
    setOpenModalNaranja,
    cantidadServicios,
    cantidadServiciosTotal,
    obtenerDirecciones,
    obtenerMapa,
    obtenerServiciosDni,
    obtenerCantidadServiciosTitularColores,
  } = serviciosContext;

  const configuracionContext = useContext(ConfiguracionContext);
  const {
    tope,
    adicionales,
    antecedentes,
    tratamientos,
    motivosConsultas,
    coseguroServicio,
    parametros,
    configuracion,
    coseguroAbonar,
    obrasSocialesMedicas,
    obtenerCoseguroServicio,
    guardarCoseguroServicio,
    guardarCoseguroAbonar,
    obtenerObrasSocialesRecetario,
    obtenerTopeColores,
  } = configuracionContext;

  const alertContext = useContext(AlertContext);
  const { mensajeAlerta } = alertContext;
  let navigate = useNavigate();

  //const classes = useStyles({color: afiliado ? afiliado.motivoConsultaColor : null });

  useEffect(() => {
    if (configuracion && configuracion.destinatario !== 4) {
      mostrarAlertaTopes();
    }
  }, []);

  useEffect(() => {
    if (
      configuracion &&
      configuracion.destinatario === 4 &&
      afiliado && tope !== null && 
      tope.colorId === afiliado.motivoConsultaColorId
    ) {
      mostrarAlertaTopes();
    }
  }, [cantidadServicios]);

  useEffect(() => {
    //mostrarDomicilio();
    //mostrarAlertaTopes();
    setTimeout(() => {
      mostrarObservaciones();
    }, 1000);
    setTimeout(() => {
      mostrarAdicionales();
    }, 1000);
  }, []);

  function clearLocalidad() {
    guardarAfiliado({
      ...afiliado,
      localidad: "",
    });
  }

  //Dialog

  //const theme = useTheme();
  //const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [open, setOpen] = useState(false);
  const [checkedGeo, setCheckedGeo] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const calcularEdad = (fecha) => {
    var hoy = new Date();
    var cumpleanos = new Date(fecha);
    var edad = hoy.getFullYear() - cumpleanos.getFullYear();
    var m = hoy.getMonth() - cumpleanos.getMonth();

    if (m < 0 || (m === 0 && hoy.getDate() < cumpleanos.getDate())) {
      edad--;
    }
    return edad;
  };

  const mostrarObservaciones = () => {
    if (
      titular &&
      titular.observacionesgenerales !== null &&
      titular.observacionesgenerales.trim() !== "" &&
      titular.observacionesgenerales.length > 1
    ) {
      toast.current.show({
        severity: "info",
        sticky: true,
        closable: true,
        content: (
          <div
            className="p-flex p-flex-column"
            style={{ flex: "1", marginLeft: "1em" }}
          >
            <div className="p-text-center">
              <i
                className="pi pi-exclamation-triangle"
                style={{ fontSize: "3rem" }}
              ></i>
              <h4>{`Observaciones`}</h4>
              <h6>{titular.observacionesgenerales}</h6>
            </div>
          </div>
        ),
      });
    }
  };

  const mostrarResumenTotalServicios = () => {
    console.log(cantidadServiciosTotal);
  };

  const mostrarAlertaTopes = () => {
    if (
      tope !== null &&
      cantidadServicios >= tope.cantidad &&
      tope.cantidad > 0 &&
      tope.habilitado 
    ) {

      guardarAfiliado({
        ...afiliado,
        tope: true,
      });

      toastC.current.show({
        severity: "error",
        sticky: true,
        closable: true,
        content: (
          <div
            className="p-flex p-flex-column"
            style={{ flex: "1", marginLeft: "1em" }}
          >
            <div className="p-text-center">
              <i
                className="pi pi-exclamation-triangle"
                style={{ fontSize: "3rem" }}
              ></i>
              <h4>{`Aviso`}</h4>
              {configuracion && configuracion.destinatario !== 4 ?
                <h4>{`El afiliado ${tope.titularId}-${tope.nombre} ha superado el tope de servicios. (${cantidadServicios}/${tope.cantidad})`}</h4>
               :
               <h6>{`El afiliado ${tope.titularId}-${tope.nombre} ha superado el tope de servicios ${afiliado.motivoConsultaColor}. (${cantidadServicios}/${tope.cantidad})`}</h6>
              } 
            </div>
          </div>
        ),
      });
    } else {
      guardarAfiliado({
        ...afiliado,
        tope: false,
      });
    }

    if (
      tope !== null &&
      cantidadServicios < tope.cantidad &&
      tope.cantidad > 0 &&
      tope.habilitado &&
      configuracion &&
      configuracion.destinatario === 2
    ) {
      toastTL.current.show({
        severity: "warn",
        sticky: true,
        closable: true,
        content: (
          <div
            className="p-flex p-flex-column"
            style={{ flex: "1", marginLeft: "1em" }}
          >
            <div className="p-text-center">
              <i
                className="pi pi-exclamation-triangle"
                style={{ fontSize: "3rem" }}
              ></i>
              <h4>{`Aviso`}</h4>
              <h6>{`El afiliado ${tope.titularId}-${tope.nombre} tiene ${cantidadServicios}/${tope.cantidad} del tope de servicios.`}</h6>
            </div>
          </div>
        ),
      });
    }
  };

  const mostrarAdicionales = () => {
    if (adicionales !== null) {
      toastTL.current.show({
        severity: "error",
        sticky: true,
        closable: true,
        content: (
          <div
            className="p-flex p-flex-column"
            style={{ flex: "1", marginLeft: "1em" }}
          >
            <div className="p-text-center">
              <i
                className="pi pi-exclamation-triangle"
                style={{ fontSize: "3rem" }}
              ></i>
              <h4>{`Aviso`}</h4>
              <h6>{`El afiliado ${adicionales.id_titular} posee módulo MAD.`}</h6>
            </div>
          </div>
        ),
      });
    }
  };

  const mostrarDomicilio = () => {
    toast.current.show({
      severity: "info",
      sticky: true,
      closable: true,
      content: (
        <div
          className="p-flex p-flex-column"
          style={{ flex: "1", marginLeft: "1em" }}
        >
          <div className="p-text-center">
            <i
              className="pi pi-exclamation-triangle"
              style={{ fontSize: "3rem" }}
            ></i>
            <h4>{`Domicilio`}</h4>
            <h6>{afiliado.domicilio}</h6>
          </div>
        </div>
      ),
    });
  };

  // Leer tecla y foco

  const handleInputBlur = (event) => {
    if (
      event &&
      event.relatedTarget &&
      event.relatedTarget.id === "provincia"
    ) {
      return;
    }

    /*    
    const close = document.getElementsByClassName(
      "MuiAutocomplete-clearIndicator"
    )[0];

    setTimeout(() => {
      if (close) {
        close.click();
      }
    }, 100);
    */

    clearLocalidad();
    obtenerDirecciones({
      domicilio: afiliado.domicilio ? afiliado.domicilio.toLowerCase() : null,
      provincia: afiliado.provincia ? afiliado.provincia.toLowerCase() : null,
    });
  };

  function onSearchtermChange(value) {
    console.log(value);
    return;
    /*
    if (event.keyCode === 13) {
      obtenerDirecciones({ domicilio: afiliado.domicilio.toLowerCase() });
    }
    */
  }

  const handleInputBlurDni = async (event) => {
    if (configuracion.destinatario === 4 || configuracion.destinatario === 6) {
      await obtenerServiciosDni({ dni: afiliado.dni });
      setTimeout(() => {
        let elem = document.getElementById("mostrarServiciosDni");
        if (elem) {
          elem.click();
        }
      }, 1000);
    }
  };

  function handleEnter(event) {
    if (event.keyCode === 13) {
      let element = event.target.id;
      let campo = null;

      switch (element) {
        case "dni":
          campo = document.getElementById("nombre");
          campo.focus();
          break;
        case "nombre":
          campo = document.getElementById("telefono");
          campo.focus();
          break;
        case "telefono":
          campo = document.getElementById("provincia");
          campo.focus();
          break;
        case "provincia":
          campo = document.getElementById("domicilio");
          campo.focus();
          break;
        case "domicilio":
          campo = document.getElementById("domicilioGeo");
          campo.focus();
          break;
        case "domicilioGeo":
          campo = document.getElementById("entre");
          campo.focus();
          break;
        case "entre":
          campo = document.getElementById("localidad");
          campo.focus();
          break;
        case "localidad":
          campo = document.getElementById("edad");
          campo.focus();
          break;
        case "edad":
          campo = document.getElementById("sexo");
          campo.focus();
          break;
        case "sexo":
          campo = document.getElementById("antecedente");
          campo.focus();
          break;
        case "antecedente":
          campo = document.getElementById("tratamiento");
          campo.focus();
          break;
        case "tratamiento":
          campo = document.getElementById("motivoConsulta");
          campo.focus();
          break;
        case "motivoConsulta":
          campo = document.getElementById("operadorEmisor");
          campo.focus();
          break;
        case "operadorEmisor":
          campo = document.getElementById("indicativoEmisor");
          campo.focus();
          break;
        case "indicativoEmisor":
          campo = document.getElementById("obraSocial");
          campo.focus();
          break;
        case "obraSocial":
          campo = document.getElementById("nroObraSocial");
          campo.focus();
          break;
        case "nroObraSocial":
          campo = document.getElementById("coseguro");
          campo.focus();
          break;
        case "coseguro":
          campo = document.getElementById("covid");
          campo.focus();
          break;
        case "covid":
          campo = document.getElementById("fueraZona");
          campo.focus();
          break;
        case "fueraZona":
          campo = document.getElementById("celular");
          campo.focus();
          break;
        case "videollamada":
          campo = document.getElementById("observaciones");
          campo.focus();
          break;
        case "celular":
          campo = document.getElementById("videollamada");
          campo.focus();
          break;
      }
    }

    if (event.keyCode === 27) {
      let element = event.target.id;
      let campo = null;

      switch (element) {
        case "nombre":
          campo = document.getElementById("dni");
          campo.focus();
          break;
        case "telefono":
          campo = document.getElementById("nombre");
          campo.focus();
          break;
        case "provincia":
          campo = document.getElementById("telefono");
          campo.focus();
          break;
        case "domicilio":
          campo = document.getElementById("provincia");
          campo.focus();
          break;
        case "domicilioGeo":
          campo = document.getElementById("domicilio");
          campo.focus();
          break;
        case "entre":
          campo = document.getElementById("domicilioGeo");
          campo.focus();
          break;
        case "localidad":
          campo = document.getElementById("entre");
          campo.focus();
          break;
        case "edad":
          campo = document.getElementById("localidad");
          campo.focus();
          break;
        case "sexo":
          campo = document.getElementById("edad");
          campo.focus();
          break;
        case "antecedente":
          campo = document.getElementById("sexo");
          campo.focus();
          break;
        case "tratamiento":
          campo = document.getElementById("antecedente");
          campo.focus();
          break;
        case "motivoConsulta":
          campo = document.getElementById("tratamiento");
          campo.focus();
          break;
        case "operadorEmisor":
          campo = document.getElementById("motivoConsulta");
          campo.focus();
          break;
        case "indicativoEmisor":
          campo = document.getElementById("operadorEmisor");
          campo.focus();
          break;
        case "obraSocial":
          campo = document.getElementById("indicativoEmisor");
          campo.focus();
          break;
        case "nroObraSocial":
          campo = document.getElementById("obraSocial");
          campo.focus();
          break;
        case "covid":
          campo = document.getElementById("coseguro");
          campo.focus();
          break;
        case "coseguro":
          campo = document.getElementById("nroObraSocial");
          campo.focus();
          break;
        case "fueraZona":
          campo = document.getElementById("covid");
          campo.focus();
          break;
        case "videollamada":
          campo = document.getElementById("fueraZona");
          campo.focus();
          break;
        case "celular":
          campo = document.getElementById("videollamada");
          campo.focus();
          break;
        case "observaciones":
          campo = document.getElementById("celular");
          campo.focus();
          break;
      }
    }
  }

  let campo = null;
  if (afiliado && titular && iniciarCursor === 0) {
    if (afiliado.id === titular.id && afiliado.grupoId !== 1) {
      campo = document.getElementById("dni");
      if (campo) {
        guardarAfiliadoCartera(false);
        setIniciarCursor(1);
        guardarAfiliado({
          ...afiliado,
          id: "00000000000000000000",
          nombre: "",
          dni: "",
          telefono: "",
          edad: "",
          sexo: null,
          antecedenteId: null,
          antecedenteNombre: "",
          tratamientoId: null,
          tratamientoNombre: "",
          motivoConsultaId: null,
          motivoConsultaNombre: "",
          nacimiento: null,
          obraSocial: null,
          nroObraSocial: null,
        });
      }
    } else {
      campo = document.getElementById("dni");
      if (campo) {
        guardarAfiliadoCartera(true);
        setIniciarCursor(1);
      }
    }
  }

  if (iniciarCursor === 1) {
    let campo = null;
    if (afiliadoCartera) {
      campo = document.getElementById("dni");
    } else {
      campo = document.getElementById("dni");
    }
    campo.focus();
    setIniciarCursor(2);
  }

  const displayCoseguro = (value, consulta) => {
    //console.log(afiliado, value)
    let index = motivosConsultas.findIndex((item) => item.id === value);
    let servicioId = motivosConsultas[index].servicioId;
    let servicioNombre = motivosConsultas[index].nombre;

    obtenerCoseguroServicio({
      servicio: servicioId,
      afiliado,
      titular,
      nombre: servicioNombre,
    });
  };

  const verificarPantalla = (color, traslado) => {
    if (traslado) {
      setTimeout(() => {
        guardarTomaAzul({
          retorno: false,
          espera: 0,
          provincia: "Buenos Aires",
          destino: null,
        });
        setOpenModalAzul(true);
      }, 2000);
    }
    if (color === "NARANJA") {
      setTimeout(() => {
        guardarTomaNaranja({
          contacto: "",
          telefono: "",
          cantidadMoviles: 1,
          dotacion: "",
          tipoEvento: "",
          descripcion: "",
          cantidadPersonas: "",
          responsable: "",
        });
        setOpenModalNaranja(true);
      }, 2000);
    }
  };

  const renderHeaderMapa = () => {
    return (
      <div>
        <Tag value="Ubicación en el Mapa"></Tag>
      </div>
    );
  };

  const renderFooterMapa = () => {
    return (
      <div>
        <Button
          label="Cerrar"
          icon="pi pi-times"
          onClick={() => handleClose()}
          className="p-button-text"
        />
      </div>
    );
  };

  function PopupExample(e) {
    if (
      afiliado.lat === undefined ||
      afiliado.lat === null ||
      afiliado.lon === undefined ||
      afiliado.lon === null
    ) {
      return;
    }

    let position = [];
    position.push(afiliado.lat);
    position.push(afiliado.lon);

    return (
      <MapContainer
        center={position}
        zoom={15}
        style={{ height: "60vh", width: "60vh" }}
      >
        <TileLayer
          attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        <Marker position={position}></Marker>
      </MapContainer>
    );
  }

  if (coseguroServicio !== null && toast.current) {
    toast.current.show({
      severity: "info",
      summary:
        coseguroServicio.mensaje + " Consulta: " + coseguroServicio.servicio,
      detail: "Valor Coseguro: " + coseguroServicio.cartel,
      sticky: false,
      life: 5000,
    });
    guardarCoseguroServicio(null);
  }

  const mostrarServiciosDni = () => {
    toast.current.show({
      severity: serviciosDni && serviciosDni.deuda>0 ? "warn" : "success",
      sticky: serviciosDni && serviciosDni.deuda>0 ? true : false,
      life: 3000,
      content: (
        <div
          className="p-flex p-flex-column"
          style={{ flex: "1", marginLeft: "1em" }}
        >
          <div className="p-text-center">
            <i
              className="pi pi-exclamation-triangle"
              style={{ fontSize: "3rem" }}
            ></i>
            { serviciosDni && serviciosDni.deuda>0 ?
            <h4>{`Este paciente tiene deuda de coseguro por $ ${serviciosDni.deuda} en los servicios ${serviciosDni.ind}.`}</h4>
            : 
            <h4>{`Este paciente no tiene deuda de coseguro`}</h4>
            }
          </div>
        </div>
      ),
    });


    toast.current.show({
      severity: "info",
      sticky: false,
      life: 5000,
      content: (
        <div
          className="p-flex p-flex-column"
          style={{ flex: "1", marginLeft: "1em" }}
        >
          <div className="p-text-center">
            <i
              className="pi pi-exclamation-triangle"
              style={{ fontSize: "3rem" }}
            ></i>
            <h4>{`Este paciente solicito ${serviciosDni.cantidadMes} servicios (VERDE - BLANCO - AMARILLO) en el mes}.`}</h4>
          </div>
        </div>
      ),
    });
  };

  function opcionNo() {
    toast.current.clear();
  }

  const itemTemplate = (data) => {
    return (
      <Grid container spacing={2} style={{ padding: "0" }}>
        <Grid item xs={12} md={6}>
          <div style={{ fontWeight: "bold", marginLeft: "1vw" }}>
            <div className="text-2xl font-bold text-900">ID: {data.id}</div>
            <div className="text-700">Fecha: {formatDate(data.fpasado)}</div>
            <div className="text-700">Color: {data.color}</div>
            <div className="text-700">
              Coseguro a Abonar: {data.coseguroAbonar}
            </div>
            <div className="text-700">
              Coseguro Abonado: {data.coseguroAbonado}
            </div>
          </div>
          <hr />
        </Grid>
        <Grid item xs={12} md={6}>
          <div style={{ fontWeight: "bold", marginLeft: "1vw" }}>
            <div className="text-700">
              Antecedentes: {data.antecedentes.nombre}
            </div>
            <div className="text-700">
              Tratamiento: {data.tratamientos.nombre}
            </div>
            <div className="text-700">
              M. Consulta: {data.motivosConsultas.nombre}
            </div>
            <div className="text-700">
              Diagnóstico: {data.diagnosticos.nombre}
            </div>
            <div className="text-700">Detalle: {data.detalleDiagnostico}</div>
          </div>
          <hr />
        </Grid>
      </Grid>
    );
  };

  function formatDate(dateString) {
    var allDate = dateString.replace("T", " ");
    allDate = allDate.replace(".", " ");
    allDate = allDate.split(" ");
    var thisDate = allDate[0].split("-");
    var newDate = [thisDate[2], thisDate[1], thisDate[0]].join("/");
    return newDate;
  }

  //console.log(afiliado);
  //console.log(tope);

  return (
    <Root className={classes.root}>
      <Fragment>
        {afiliado && antecedentes && tratamientos && motivosConsultas ? (
          <Fragment>
            <Toast ref={toast} />
            <Toast ref={toastC} position="center"></Toast>
            <Toast ref={toastTL} position="top-left"></Toast>
            <Toast ref={toastBL} position="bottom-left"></Toast>
            <Grid container spacing={2} style={{ padding: "0" }}>
              <Grid item xs={12} md={6}>
                <TextField
                  id="titular"
                  label="Titular"
                  value={
                    afiliado && titular
                      ? afiliado.titularId + " - " + titular.nombre_razonsocial
                      : null
                  }
                  fullWidth
                  variant="standard"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  size="small"
                  disabled={true}
                  sx={{
                    "& .MuiInputBase-input.Mui-disabled": {
                      WebkitTextFillColor: "black",
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <TextField
                  id="plan"
                  label="Plan"
                  value={afiliado ? afiliado.plan : null}
                  fullWidth
                  variant="standard"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  size="small"
                  disabled={true}
                  sx={{
                    "& .MuiInputBase-input.Mui-disabled": {
                      WebkitTextFillColor: "black",
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} md={2}>
                <TextField
                  id="id"
                  label="ID"
                  value={afiliado ? afiliado.id : null}
                  fullWidth
                  variant="standard"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  size="small"
                  disabled={true}
                  sx={{
                    "& .MuiInputBase-input.Mui-disabled": {
                      WebkitTextFillColor: "black",
                    },
                  }}
                />
              </Grid>
              <Grid item xs={12} md={1}>
                <NumericFormat
                  {...props}
                  id="dni"
                  label="D.N.I."
                  customInput={TextField}
                  format="########"
                  type="numeric"
                  value={afiliado ? afiliado.dni : null}
                  fullWidth
                  variant="standard"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  required
                  size="small"
                  //disabled={afiliadoCartera ? true : false}
                  onBlur={(e) => handleInputBlurDni(e)}
                  onKeyDown={handleEnter}
                  onChange={(e) =>
                    guardarAfiliado({
                      ...afiliado,
                      dni: e.target.value,
                    })
                  }
                />
              </Grid>
              <Grid item xs={12} md={5}>
                <TextField
                  id="nombre"
                  label="Apellido y Nombre"
                  value={afiliado ? afiliado.nombre : null}
                  required
                  fullWidth
                  variant="standard"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  size="small"
                  //disabled={afiliadoCartera ? true : false}
                  onKeyDown={handleEnter}
                  onChange={(e) =>
                    guardarAfiliado({
                      ...afiliado,
                      nombre: e.target.value.toUpperCase(),
                    })
                  }
                />
              </Grid>
              <Grid item xs={12} md={2}>
                <TextField
                  id="telefono"
                  label="Teléfono"
                  value={afiliado ? afiliado.telefono : null}
                  required
                  fullWidth
                  variant="standard"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  size="small"
                  onKeyDown={handleEnter}
                  onChange={(e) =>
                    guardarAfiliado({
                      ...afiliado,
                      telefono: e.target.value,
                    })
                  }
                />
              </Grid>

              <Grid item xs={12} md={2}>
                <TextField
                  id="provincia"
                  label="Provincia"
                  value={afiliado ? afiliado.provincia : null}
                  required
                  fullWidth
                  variant="standard"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  size="small"
                  onKeyDown={handleEnter}
                  onChange={(e) =>
                    guardarAfiliado({
                      ...afiliado,
                      provincia: e.target.value,
                    })
                  }
                />
              </Grid>

              <Grid item xs={12} md={4}>
                <TextField
                  id="domicilio"
                  label="Dirección"
                  value={afiliado ? afiliado.domicilio : null}
                  fullWidth
                  variant="standard"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  size="small"
                  onKeyDown={handleEnter}
                  onBlur={(e) => handleInputBlur(e)}
                  onChange={(e) =>
                    guardarAfiliado({
                      ...afiliado,
                      domicilio: e.target.value,
                    })
                  }
                />
              </Grid>

              <Grid item xs={12} md={4}>
                <Autocomplete
                  id="domicilioGeo"
                  fullWidth
                  noOptionsText={"No hay opciones"}
                  options={direcciones}
                  getOptionLabel={(option) => option.label}
                  openOnFocus={true}
                  disablePortal
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Dirección Geolocalizada"
                      variant="standard"
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  )}
                  onKeyDown={handleEnter}
                  onChange={(event, value) => {
                    if (value) {
                      guardarAfiliado({
                        ...afiliado,
                        domicilioGeo: value.label,
                        localidadGeo: value.localidad
                          ? value.localidad.toUpperCase()
                          : null,
                        localidad:
                          value.provincia &&
                          value.provincia.search("Provincia") !== -1
                            ? value.localidad.toUpperCase()
                            : value.provincia
                            ? value.provincia.toUpperCase()
                            : null,
                        lat: value.lat,
                        lon: value.lon,
                      });
                      campo = document.getElementById("entre");
                      campo.focus();
                    } else {
                      guardarAfiliado({
                        ...afiliado,
                        domicilioGeo: null,
                        localidadGeo: null,
                        lat: null,
                        lon: null,
                      });
                    }
                  }}
                />
              </Grid>

              <Grid item xs={4} md={1}>
                <IconButton
                  type="submit"
                  aria-label="search"
                  onClick={(e) => handleClickOpen()}
                >
                  <SearchIcon />
                </IconButton>
              </Grid>

              <Grid item xs={12} md={3}>
                <TextField
                  id="entre"
                  label="Entre calles"
                  value={afiliado ? afiliado.entreCalles : null}
                  fullWidth
                  variant="standard"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  size="small"
                  onKeyDown={handleEnter}
                  onChange={(e) =>
                    guardarAfiliado({
                      ...afiliado,
                      entreCalles: e.target.value,
                    })
                  }
                />
              </Grid>

              <Grid item xs={12} md={3}>
                <TextField
                  id="localidad"
                  label="Localidad"
                  value={afiliado.localidad}
                  fullWidth
                  variant="standard"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  size="small"
                  //disabled={afiliadoCartera ? true : false}
                  onKeyDown={handleEnter}
                  onChange={(e) =>
                    guardarAfiliado({
                      ...afiliado,
                      localidad: e.target.value.toUpperCase(),
                    })
                  }
                />
              </Grid>

              <Grid item xs={12} md={1.4}>
                <TextField
                  id="nacimiento"
                  label="Nacimiento"
                  type="date"
                  fullWidth
                  value={afiliado?.nacimiento ? afiliado.nacimiento.split("T")[0] : ""}
                  variant="standard"
                  //onKeyDown={handleEnter}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onChange={(e) => {
                    if (e.target.value) {
                      guardarAfiliado({
                        ...afiliado,
                        nacimiento: e.target.value,
                        edad: calcularEdad(e.target.value),
                      });
                    } else {
                      guardarAfiliado({
                        ...afiliado,
                        nacimiento: null,
                      });
                    }
                  }}
                />
              </Grid>

              <Grid item xs={12} md={0.5}>
                <NumericFormat
                  {...props}
                  id="edad"
                  label="Edad"
                  customInput={TextField}
                  format="###"
                  type="numeric"
                  fullWidth
                  value={afiliado.edad}
                  variant="standard"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  size="small"
                  required
                  disabled={afiliado.nacimiento}
                  onKeyDown={handleEnter}
                  onChange={(e) =>
                    guardarAfiliado({
                      ...afiliado,
                      edad: e.target.value,
                    })
                  }
                />
              </Grid>

              <Grid item xs={12} md={1}>
                <FormControl fullWidth onKeyDown={handleEnter}>
                  <InputLabel id="simple-select-label-sexo">Sexo</InputLabel>
                  <Select
                    labelId="Sexo"
                    id="sexo"
                    required
                    value={afiliado ? afiliado.sexo : null}
                    variant="standard"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    onChange={(e) =>
                      guardarAfiliado({
                        ...afiliado,
                        sexo: e.target.value,
                      })
                    }
                  >
                    <MenuItem value={1}>M</MenuItem>
                    <MenuItem value={2}>F</MenuItem>
                  </Select>{" "}
                </FormControl>
              </Grid>
              <Grid item xs={12} md={3}>
                <Autocomplete
                  id="antecedente"
                  fullWidth
                  required
                  noOptionsText={"No hay opciones"}
                  options={antecedentes}
                  defaultValue={
                    antecedentes && afiliado && afiliado.antecedenteId
                      ? antecedentes[
                          antecedentes.findIndex(
                            (item) => item.id === afiliado.antecedenteId
                          )
                        ]
                      : null
                  }
                  getOptionLabel={(option) => option.nombre}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Antecedente"
                      variant="standard"
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  )}
                  onKeyDown={handleEnter}
                  onChange={(event, value) => {
                    if (value) {
                      guardarAfiliado({
                        ...afiliado,
                        antecedenteId: value.id,
                        antecedenteNombre: value.nombre,
                      });
                    }
                  }}
                />
              </Grid>

              <Grid item xs={12} md={3}>
                <Autocomplete
                  id="tratamiento"
                  fullWidth
                  disablePortal
                  required
                  noOptionsText={"No hay opciones"}
                  options={tratamientos}
                  defaultValue={
                    tratamientos && afiliado && afiliado.tratamientoId
                      ? tratamientos[
                          tratamientos.findIndex(
                            (item) => item.id === afiliado.tratamientoId
                          )
                        ]
                      : null
                  }
                  getOptionLabel={(option) => option.nombre}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Tratamiento"
                      variant="standard"
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  )}
                  onKeyDown={handleEnter}
                  onChange={(event, value) => {
                    if (value) {
                      guardarAfiliado({
                        ...afiliado,
                        tratamientoId: value.id,
                        tratamientoNombre: value.nombre,
                      });
                    }
                  }}
                />
              </Grid>
              <Grid item xs={11} md={5}>
                <Autocomplete
                  id="motivoConsulta"
                  fullWidth
                  required
                  disablePortal
                  debug
                  noOptionsText={"No hay opciones"}
                  options={
                    configuracion &&
                    configuracion.destinatario === 1 &&
                    afiliado &&
                    (afiliado.planId === 38 || afiliado.planId === 39)
                      ? motivosConsultas.filter(
                          (element) =>
                            element.color === "ROJO" ||
                            element.color === "VERDE"
                        )
                      : motivosConsultas
                  }
                  //classes={classes }

                  getOptionLabel={(option) => option.nombre}
                  /*
                  renderOption={(props, option: AcOption) => (
                    <li {...props}>{option.code}&nbsp;&nbsp;&nbsp;{option.description}</li>
                  )}
                  */

                  renderOption={(props, option) => {
                    const { nombre, codColor } = option;
                    return (
                      <li
                        {...props}
                        style={{
                          backgroundColor: codColor,
                          color:
                            codColor === "#FFFF00" ||
                            codColor === "#FFFFFF" ||
                            codColor === "#00FFFF"
                              ? "#000000"
                              : "#FFFFFF",
                        }}
                      >
                        {nombre}
                      </li>
                    );
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Motivo de consulta"
                      variant="standard"
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  )}
                  onKeyDown={handleEnter}
                  onChange={(event, value) => {
                    if (value) {
                      //console.log(value);
                      guardarAfiliado({
                        ...afiliado,
                        motivoConsultaId: value.id,
                        motivoConsultaNombre: value.nombre,
                        motivoConsultaCodigoColor: value.codColor,
                        motivoConsultaColor: value.color,
                        motivoConsultaTraslado: value.traslado,
                        motivoConsultaColorId: value.colorId,
                      });
                      guardarCoseguroServicio(null);
                      displayCoseguro(value.id);
                      verificarPantalla(value.color, value.traslado);
                      if (
                        configuracion &&
                        configuracion.institucionId &&
                        configuracion.whapi &&
                        value.color === "BLANCO"
                      ) {
                        obtenerObrasSocialesRecetario();
                      }
                      if (configuracion && configuracion.destinatario === 4) {
                        obtenerTopeColores({
                          titularId: titular.id_titular,
                          colorId: value.colorId,
                        });
                        obtenerCantidadServiciosTitularColores({
                          titularId: titular.id_titular,
                          color: value.color,
                        });
                      }
                    } else {
                      guardarAfiliado({
                        ...afiliado,
                        motivoConsultaId: null,
                        motivoConsultaNombre: null,
                        motivoConsultaCodigoColor: null,
                        motivoConsultaColor: null,
                        motivoConsultaTraslado: null,
                        motivoConsultaColorId: null,
                      });
                    }
                  }}
                />
              </Grid>
              <Grid item xs={1} md={1}>
                <Button
                  size="normal"
                  variant="outlined"
                  style={{
                    marginTop: "0.5em",
                    backgroundColor: afiliado.motivoConsultaCodigoColor
                      ? afiliado.motivoConsultaCodigoColor
                      : "#FFF",
                    color:
                      afiliado.motivoConsultaColor === "AMARILLO" ||
                      afiliado.motivoConsultaColor === "CELESTE" ||
                      afiliado.motivoConsultaColor === "BLANCO"
                        ? "#000000"
                        : "#FFFFFF",
                  }}
                >
                  {afiliado && afiliado.motivoConsultaColor !== null
                    ? afiliado.motivoConsultaColor
                    : "Color"}
                </Button>
              </Grid>

              <Grid item xs={6} md={3}>
                <TextField
                  id="operadorEmisor"
                  label="Operador emisor"
                  fullWidth
                  variant="standard"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  size="small"
                  onKeyDown={handleEnter}
                  onChange={(e) =>
                    guardarAfiliado({
                      ...afiliado,
                      operadorEmisor: e.target.value,
                    })
                  }
                />
              </Grid>
              <Grid item xs={6} md={3}>
                <TextField
                  id="indicativoEmisor"
                  label="Indicativo emisor"
                  fullWidth
                  variant="standard"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  size="small"
                  onKeyDown={handleEnter}
                  onChange={(e) =>
                    guardarAfiliado({
                      ...afiliado,
                      indicativoEmisor: e.target.value,
                    })
                  }
                />
              </Grid>
              <Grid item xs={6} md={2.5}>
                {configuracion.institucionId &&
                configuracion.whapi &&
                afiliado &&
                afiliado.motivoConsultaColor === "BLANCO" ? (
                  <Dropdown
                    value={
                      obrasSocialesMedicas && afiliado && afiliado.obraSocial
                        ? obrasSocialesMedicas[
                            obrasSocialesMedicas.findIndex(
                              (element) => element.name === afiliado.obraSocial
                            )
                          ]
                        : null
                    }
                    onChange={(e) => {
                      if (e.value) {
                        if (
                          e.value.name === "ostee" &&
                          configuracion.destinatario === 4
                        ) {
                          guardarAfiliado({
                            ...afiliado,
                            obraSocial: e.value.name,
                            nroObraSocial: "PRES 46427",
                          });
                        } else {
                          guardarAfiliado({
                            ...afiliado,
                            obraSocial: e.value.name,
                          });
                        }
                      } else {
                        guardarAfiliado({
                          ...afiliado,
                          obraSocial: null,
                        });
                      }
                    }}
                    options={obrasSocialesMedicas}
                    optionLabel="name"
                    showClear
                    filter
                    placeholder="Seleccione obra social"
                    className="w-100"
                    style={{ marginLeft: "0vw", marginTop: "0vw" }}
                  />
                ) : (
                  <TextField
                    id="obraSocial"
                    label="Obra social/Convenio"
                    fullWidth
                    variant="standard"
                    size="small"
                    value={afiliado ? afiliado.obraSocial : null}
                    InputLabelProps={{ style: { fontSize: 14 }, shrink: true }} // font size of input label
                    onKeyDown={handleEnter}
                    onChange={(e) =>
                      guardarAfiliado({
                        ...afiliado,
                        obraSocial: e.target.value,
                      })
                    }
                  />
                )}
              </Grid>

              <Grid item xs={6} md={1.5}>
                <TextField
                  id="nroObraSocial"
                  label="Nro. Obra social/Convenio"
                  fullWidth
                  value={afiliado ? afiliado.nroObraSocial : null}
                  variant="standard"
                  size="small"
                  InputLabelProps={{ style: { fontSize: 12 }, shrink: true }} // font size of input label
                  onKeyDown={handleEnter}
                  onChange={(e) =>
                    guardarAfiliado({
                      ...afiliado,
                      nroObraSocial: e.target.value,
                    })
                  }
                />
              </Grid>

              <Grid item xs={6} md={1}>
                <TextField
                  id="coseguro"
                  label="Coseguro"
                  fullWidth
                  variant="standard"
                  size="small"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onKeyDown={handleEnter}
                  value={coseguroAbonar}
                  onChange={(e) => guardarCoseguroAbonar(e.target.value)}
                />
              </Grid>

              <Grid item xs={12} md={1.5} style={{ paddingLeft: 0 }}>
                <FormControlLabel
                  value="yes"
                  control={
                    <Checkbox
                      id="covid"
                      color="primary"
                      checked={afiliado ? afiliado.covid : false}
                      onKeyDown={handleEnter}
                      onChange={(e) =>
                        guardarAfiliado({
                          ...afiliado,
                          covid: e.target.checked,
                        })
                      }
                    />
                  }
                  label="Covid"
                  labelPlacement="start"
                />
              </Grid>

              <Grid item xs={12} md={1.5} style={{ paddingLeft: 0 }}>
                <FormControlLabel
                  value="yes"
                  control={
                    <Checkbox
                      id="fueraZona"
                      color="primary"
                      checked={afiliado ? afiliado.fueraZona : false}
                      onKeyDown={handleEnter}
                      onChange={(e) =>
                        guardarAfiliado({
                          ...afiliado,
                          fueraZona: e.target.checked,
                        })
                      }
                    />
                  }
                  label="Fuera de Zona"
                  labelPlacement="start"
                />
              </Grid>

              <Grid item xs={12} md={1.5} style={{ paddingLeft: 0 }}>
                <FormControlLabel
                  value="yes"
                  control={
                    <Checkbox
                      id="videollamada"
                      color="primary"
                      checked={afiliado ? afiliado.videollamada : false}
                      onKeyDown={handleEnter}
                      onChange={(e) =>
                        guardarAfiliado({
                          ...afiliado,
                          videollamada: e.target.checked,
                        })
                      }
                    />
                  }
                  label="Videollamada"
                  labelPlacement="start"
                />
              </Grid>

              <Grid item xs={12} md={1.5}>
                <TextField
                  id="celular"
                  label="WhatsApp"
                  value={afiliado ? afiliado.celular : null}
                  required
                  fullWidth
                  variant="standard"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  size="small"
                  onKeyDown={handleEnter}
                  onChange={(e) =>
                    guardarAfiliado({
                      ...afiliado,
                      celular: e.target.value,
                    })
                  }
                />
              </Grid>

              <Grid item xs={12} md={1.5} style={{ paddingLeft: 0 }}>
                <FormControlLabel
                  value="yes"
                  control={
                    <Checkbox
                      id="rederivado"
                      color="primary"
                      checked={afiliado ? afiliado.rederivado : false}
                      onKeyDown={handleEnter}
                      onChange={(e) =>
                        guardarAfiliado({
                          ...afiliado,
                          rederivado: e.target.checked,
                        })
                      }
                    />
                  }
                  label="Rederivado"
                  labelPlacement="start"
                />
              </Grid>

              <Grid item xs={12} md={1.5}>
                <TextField
                  id="indicativoRederivado"
                  label="Ind. Rederivado"
                  value={afiliado ? afiliado.indicativoRederivado : null}
                  fullWidth
                  variant="standard"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  size="small"
                  onKeyDown={handleEnter}
                  onChange={(e) =>
                    guardarAfiliado({
                      ...afiliado,
                      indicativoRederivado: e.target.value,
                    })
                  }
                />
              </Grid>


              <Grid item xs={12} md={1.5} style={{ paddingLeft: 0 }}>
                <FormControlLabel
                  value="yes"
                  control={
                    <Checkbox
                      id="simultaneo"
                      color="primary"
                      checked={afiliado ? afiliado.simultaneo : false}
                      onKeyDown={handleEnter}
                      onChange={(e) =>
                        guardarAfiliado({
                          ...afiliado,
                          simultaneo: e.target.checked,
                          cantidadSimultaneo: e.target.checked ? 2 : "",
                        })
                      }
                    />
                  }
                  label="Simultáneo"
                  labelPlacement="start"
                />
              </Grid>

              <Grid item xs={12} md={1.5}>
                <TextField
                  id="cantidadSimultaneo"
                  label="Cant. Simultáneo"
                  value={afiliado ? afiliado.cantidadSimultaneo : null}
                  fullWidth
                  variant="standard"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  size="small"
                  type="number"
                  disabled={!afiliado.simultaneo}
                  //onKeyDown={handleEnter}
                  onChange={(e) =>
                    guardarAfiliado({
                      ...afiliado,
                      cantidadSimultaneo:
                        e.target.value <= 1 ? 2 : e.target.value,
                    })
                  }
                />
              </Grid>

              <Grid item xs={12} md={1} style={{ paddingLeft: 0 }}>
                <FormControlLabel
                  value="yes"
                  control={
                    <Checkbox
                      id="covid"
                      color="primary"
                      checked={afiliado ? afiliado.camillero : false}
                      onKeyDown={handleEnter}
                      onChange={(e) =>
                        guardarAfiliado({
                          ...afiliado,
                          camillero: e.target.checked,
                        })
                      }
                    />
                  }
                  label="Camillero"
                  labelPlacement="start"
                />
              </Grid>


              <Grid item xs={12} md={5}>
                <TextField
                  id="email"
                  label="Email"
                  value={afiliado ? afiliado.email : null}
                  required
                  fullWidth
                  variant="standard"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  size="small"
                  onKeyDown={handleEnter}
                  onChange={(e) =>
                    guardarAfiliado({
                      ...afiliado,
                      email: e.target.value,
                    })
                  }
                />
              </Grid>

              <Grid item xs={12} md={4}>
                <TextareaAutosize
                  id="observaciones"
                  maxRows={5}
                  minRows={5}
                  //value={afiliado.observaciones}
                  aria-label="maximum height"
                  placeholder="Observaciones"
                  defaultValue=""
                  style={{ width: "-webkit-fill-available", marginTop: ".5em" }}
                  /*
                  onChange={(e) =>
                    guardarAfiliado({
                      ...afiliado,
                      observaciones: e.target.value,
                    })
                  }
                  */
                />
              </Grid>

              <Button
                id="mostrarServiciosDni"
                size="small"
                //variant="outlined"
                color="secondary"
                style={{ display: "none" }}
                onClick={(e) => mostrarServiciosDni()}
              >
                Mostrar Servicios Dni
              </Button>

              <Grid item xs={12} md={12}></Grid>
            </Grid>
            <div className="dialog-demo">
              <Dialog
                header={renderHeaderMapa()}
                visible={open}
                footer={renderFooterMapa()}
                closable={false}
              >
                {PopupExample()}
              </Dialog>
            </div>

            <div className="dialog-demo">
              <Dialog
                //header={renderHeaderMapa()}
                visible={visibleServiciosDni}
                //footer={renderFooterMapa()}
                closable={true}
                onHide={() => setVisibleServiciosDni(false)}
              >
                <div className="card">
                  <DataView
                    value={serviciosDni}
                    itemTemplate={itemTemplate}
                    layout="grid"
                  />
                </div>
              </Dialog>
            </div>
          </Fragment>
        ) : (
          <Spinner />
        )}
      </Fragment>
    </Root>
  );
}
